import { FORM_STATES } from '@bingads-webui-fluent-component/form';
import { PMAX_LITE_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/pmax-lite-wizard-utils';

const DelayedAgenticAnalyzeStep =
  () => import(/* webpackChunkName: "agentic-analyze-step.async" */ './agentic-analyze-step')
    .then(({ AgenticAnalyzeStepWithI18n }) => AgenticAnalyzeStepWithI18n);

const DelayedAgenticAnalyzeRepository =
  () => import(/* webpackChunkName: "agentic-analyze-step.async" */ './agentic-analyze-lazy-repository')
    .then(({ AgenticAnalyzeLazyRepositoryWithI18n }) => AgenticAnalyzeLazyRepositoryWithI18n);

export const AgenticAnalyzeStepConfig = {
  id: PMAX_LITE_WIZARD_STEP_PATHS.AGENTIC_ANALYZE,
  view: DelayedAgenticAnalyzeStep,
  repository: DelayedAgenticAnalyzeRepository,
  machineOptions: {
    initialState: FORM_STATES.FETCHING,
  },
};
